module.exports = __webpack_public_path__ + "static/media/card-image.37cf3d10.jpg";